import Vue from 'vue';
import App from './App.vue';

const root = document.getElementById('products-app');
new Vue(App).$mount(root);
